import { Component, Inject } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { AddeableComponent } from '../../../../shared/components/interfaces/addeable.component';
import { UIActiveDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { PartCategoryUIMessages } from '../../model/part-category-ui.messages';
import { PartCategoryModel } from '../../model/part-category.model';
import { PartCategoryService } from '../../service/part-category.service';

@Component({
  selector: 'part-category-add-dialog',
  templateUrl:
    'console/app-js/modules/partCategory/components/part-category-add-dialog/part-category-add-dialog.component.html'
})
export class PartCategoryAddDialogComponent extends APIOperableComponent
  implements AddeableComponent {
  protected partCategoryModel: PartCategoryModel = new PartCategoryModel();
  private originalModel: PartCategoryModel;
  private partCategoryId: number;
  private allPartCategory: Array<PartCategoryModel> = [];
  private currentPartCategoryNames: Array<string> = [];
  private profile: any;

  constructor(
    @Inject('partCategoryModel') partCategory: PartCategoryModel,
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private partCategoryService: PartCategoryService,
    private activeDialogService: UIActiveDialogService
  ) {
    super(progressService, toastr, authService);
    this.partCategoryId = partCategory ? partCategory.id : null;
    this.loadAllPartCategories();
    this.getUserName();
  }

  /**
   * Get current username from user profile.
   */
  private getUserName() {
    this.profile = this.authService.getUserInfo();
  }

  /**
   * Loads all makes and extract it's names to validate.
   */
  private loadAllPartCategories(): void {
    this.loadingIndicator = true;
    this.partCategoryService.getPartCategories().subscribe(
      result => {
        this.allPartCategory = result ? result : [];
        this.currentPartCategoryNames = this.allPartCategory.map(
          item => item.name
        );
        this.loadingIndicator = false;
      },
      err =>
        this.onAPIError(PartCategoryUIMessages.LOAD_Part_Category_LIST_ERROR)
    );
  }

  /**
   * Create new part category onSave.
   */
  onSave(): void {
    this.startProgress();
    // Create
    this.partCategoryModel.isActive = true;
    this.partCategoryService
      .createPartCategory(this.partCategoryModel)
      .subscribe(
        response => {
          if (response.responseCode === 200) {
            this.onAPISuccess(PartCategoryUIMessages.ADD_Part_Category_SUCCESS);
            this.activeDialogService.close(true);
            this.finishProgress();
          } else {
            this.onAPIError(PartCategoryUIMessages.ADD_Part_Category_ERROR);
          }
        },
        error => {
          this.onAPIError(PartCategoryUIMessages.ADD_Part_Category_ERROR);
        }
      );
  }

  /**
   * Check the form is dirty.
   */
  isDirty(): boolean {
    if (this.originalModel) {
      return (
        JSON.stringify(this.originalModel) !==
        JSON.stringify(this.partCategoryModel)
      );
    } else {
      // Create always dirty
      return true;
    }
  }

  /**
   * Cancel adding new part category.
   */
  onCancel(): void {
    this.activeDialogService.dismiss();
  }

  /**
   * Determines if the current name input by user is already in use.
   * @returns {boolean}
   */
  protected isNameInUse(): boolean {
    const match =
      this.partCategoryModel.name &&
      this.currentPartCategoryNames.find(
        item =>
          item.toLocaleLowerCase().trim() ===
          this.partCategoryModel.name.trim().toLocaleLowerCase()
      );
    if (match && this.originalModel) {
      return (
        match.toLocaleLowerCase() !==
        this.originalModel.name.toLocaleLowerCase()
      );
    }
    return match && match.length > 0;
  }

  public isValid = templateForm =>
    (templateForm.controls.name && templateForm.controls.name.errors) ||
    (templateForm.controls.description &&
      templateForm.controls.description.errors);
}
